'use strict';

import http from '@/utils/http';

export default {
  getList(code, params) {
    return http.get('/authority/applicationClient/list', { params, code });
  },
  getListByRoleId(code, roleId) {
    return http.get(`/authority/role/findAuthorityIdList/${roleId}`, { code });
  },
  add(code, data) {
    return http.post('/authority/applicationClient', data, { code });
  },
  update(code, data) {
    return http.put('/authority/applicationClient', data, { code });
  },
  delete(code, params) {
    return http.delete('/authority/applicationClient', { params, code });
  },
  saveListToRole(code, data) {
    return http.post('/authority/role/saveAppClientRoleAuthority', data, {
      code,
    });
  },
};
